import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  CallState as RewardsCallState,
  getFetchRewardsAccountsCallState,
  getRewardsAccounts,
  getRewardsAccountWithLargestEarnForBanner,
} from "../../../rewards/reducer";
import {
  getRewardsPaymentAccountReferenceId,
  getRewardsPaymentInFiatCurrency,
  getRewardsPaymentInRewardsCurrency,
  rewardsAccountMinimumRequirementStateSelector,
  getCreditToApply,
  getOfferToApply,
  getTotalVacationRentalsCreditCardPaymentRequiredNumber,
  getVacationRentalsIsCreditCardPaymentRequired,
  getTotalVacationRentalsToPay,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { RewardsSelection } from "./component";
import { actions } from "../../actions";
import { getVacationRentalShopSelectedListing } from "../../../shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  const selectedHome = getVacationRentalShopSelectedListing(state);
  return {
    rewardsAccounts: getRewardsAccounts(state),
    rewardsAccountsLoaded: [
      RewardsCallState.Success,
      RewardsCallState.Failed,
    ].includes(getFetchRewardsAccountsCallState(state)),
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
    rewardsPaymentInFiatCurrency: getRewardsPaymentInFiatCurrency(state),
    rewardsPaymentInRewardsCurrency: getRewardsPaymentInRewardsCurrency(state),
    isCreditCardPaymentRequired:
      getVacationRentalsIsCreditCardPaymentRequired(state),
    rewardsAccountMinimumRequirementState:
      rewardsAccountMinimumRequirementStateSelector(state),
    totalCreditCardPaymentRequired:
      getTotalVacationRentalsCreditCardPaymentRequiredNumber(state),
    tripTotal: getTotalVacationRentalsToPay(state),
    offerToApply: getOfferToApply(state),
    creditToApply: getCreditToApply(state),
    selectedHome,
    largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  };
};

const mapDispatchToProps = {
  setSelectedRewardsAccountId: actions.setSelectedRewardsAccountReferenceId,
  setRewardsPaymentAmount: actions.setSelectedRewardsPaymentTotal,
  fetchProductToEarn: actions.fetchProductToEarn,
  setRewardsConversionFailed: actions.setRewardsConversionFailed,
  setPaymentMethod: actions.setPaymentMethod,
  setEarnValue: actions.setEarnValue,
  fetchAllEarnForProduct: actions.fetchAllEarnForProduct,
  setAllEarnValues: actions.setAllEarnValues,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type RewardsSelectionConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedRewardsSelection = withRouter(
  connector(RewardsSelection)
);
